export const billingMethodOptions = [
  {
    title: 'Eligibility-based calculation',
    caption:
      'Calculate patient responsibility using real-time OON eligibility — deductible, coinsurance, and copayment applied automatically.',
    value: 'eligibility-calculation',
    recommended: true
  },
  {
    title: 'Down payment',
    caption: 'Collect a flat down payment upfront before treatment.',
    value: 'down-payment',
    recommended: false
  }
];

export const billingMethodAlertOptions = [
  {
    title: 'Deductible',
    description: 'remaining OON deductible applied first'
  },
  {
    title: 'Coinsurance',
    description: `patient's OON coinsurance share after deductible (e.g., 40%)`
  },
  {
    title: 'Copayment',
    description: 'fixed OON copay if applicable under the plan'
  }
];

export const patientPortionOptions = [
  {
    title: 'Use self-pay amount',
    caption: `Use the practice's established self-pay rate as the OON price per service.`,
    value: 'self-pay-amount',
    recommended: true
  },
  {
    title: 'Use charge amount',
    caption: 'Use the full billed charge amount as the OON price per service.',
    value: 'charge-amount',
    recommended: false
  },
  {
    title: 'Use allowed amount as UCR',
    caption:
      'Use the usual and customary rate recognized by the payer as the OON price per service.',
    value: 'allowed-amount-ucr',
    recommended: false
  }
];
